import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Wrench, Users } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

const ServiceModelsBlock = () => {
  const { t } = useTranslation();

  const models = [
    {
      icon: <Wrench className="h-10 w-10 text-blue-600" />,
      title: t('serviceModels.items.weBuild.title'),
      description: t('serviceModels.items.weBuild.description'),
      idealFor: t('serviceModels.items.weBuild.idealFor')
    },
    {
      icon: <Users className="h-10 w-10 text-blue-600" />,
      title: t('serviceModels.items.weEmpower.title'),
      description: t('serviceModels.items.weEmpower.description'),
      idealFor: t('serviceModels.items.weEmpower.idealFor')
    }
  ];

  return (
    <section id="service-models" className="py-20 bg-white">
      <div className="container px-4 mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{t('serviceModels.title')}</h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            {t('serviceModels.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {models.map((model, index) => (
            <Card 
              key={index} 
              className="border-gray-200 hover:shadow-lg transition-shadow duration-300"
            >
              <CardContent className="p-8">
                <div className="mb-4">{model.icon}</div>
                <h3 className="text-2xl font-bold mb-4">{model.title}</h3>
                <p className="text-gray-600 mb-6">
                  {model.description}
                </p>
                
                <div className="flex items-start mt-4 p-3 bg-blue-50 rounded-md">
                  <p className="text-blue-700 font-medium">
                    👉 {model.idealFor}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceModelsBlock; 